import React, { useContext } from 'react';
import styled from 'styled-components';
import { Text, Icon, Button, theme } from 'components';
import { AnsweringServiceType } from '@bb/domain/dist/types/AnsweringSubscription';
import { StyledIconWrapper } from '../../StyledComponents';
import ServiceLabels from '../../ServiceLabels';
import AppointmentDeskContext, {
  AppointmentDeskStep,
} from '../../AppointmentDeskContext';
import PriceEstimator from './PriceEstimator';
import { LIVE_CONCIERGE_LABELS } from '../../constants';

const LiveConciergePlan: React.FC = () => {
  const {
    association,
    answeringSubscription,
    setCurrentStep,
    setSelectedSubscriptionType,
  } = useContext(AppointmentDeskContext);

  const hasLiveConciergePlus = association?.useLiveConciergePlus;

  return (
    <StyledMainContainer>
      <StyledIconWrapper>
        <Icon type="headset" />
      </StyledIconWrapper>
      <StyledHeaderSection>
        <StyledHeaderText>Live Concierge</StyledHeaderText>
        {hasLiveConciergePlus ? (
          <StyledHeaderSubText type="secondary">
            Choose to upgrade to the Live Concierge Service which has all of the
            Appointment Desk features plus many more.{' '}
            <strong>
              The cost of the Live Concierge Service is covered by your MLS.
            </strong>
          </StyledHeaderSubText>
        ) : (
          <StyledHeaderSubText type="secondary" textAlign="center">
            Level up your answering service with a personal concierge
          </StyledHeaderSubText>
        )}
      </StyledHeaderSection>
      {!hasLiveConciergePlus && <PriceEstimator />}
      <StyledServiceLabelsContainer>
        <StyledServiceLabelText>Included</StyledServiceLabelText>
        <StyledServiceLabelSubText>
          Access to all Appointment Desk features plus
        </StyledServiceLabelSubText>
        <ServiceLabels labels={LIVE_CONCIERGE_LABELS} />
      </StyledServiceLabelsContainer>
      {answeringSubscription?.serviceType !==
        AnsweringServiceType.LiveConciergePlus && (
        <StyledSetupButton
          type="primary"
          onClick={() => {
            setSelectedSubscriptionType(AnsweringServiceType.LiveConciergePlus);
            setCurrentStep(AppointmentDeskStep.ManageListings);
          }}
          data-cy="manage-listings-button"
        >
          Enable
        </StyledSetupButton>
      )}
    </StyledMainContainer>
  );
};

export default LiveConciergePlan;

const StyledMainContainer = styled.div`
  padding: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 420px;
  min-height: 766px;
  height: 100%;
`;

const StyledHeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
`;

const StyledHeaderText = styled(Text)`
  font-size: 16px;
  font-weight: 400;
  padding-bottom: 24px;
`;

const StyledHeaderSubText = styled(Text)`
  line-height: 22px;
`;

const StyledServiceLabelsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-top: 24px;
`;

const StyledServiceLabelText = styled(Text)`
  font-size: 14px;
  font-weight: 600;
  padding-bottom: 12px;
`;

const StyledServiceLabelSubText = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  color: ${theme.gray8};
  padding-bottom: 16px;
`;

const StyledSetupButton = styled(Button)`
  width: 100%;
  font-weight: 400;
`;
